// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { fabClasses } from '@mui/material/Fab';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { typography } from '../../tokens/typography';
import { fabColors } from './fabColors';
export var Fab = function(mode) {
    var c = fabColors(mode);
    var _obj, _obj1, _obj2;
    var override = {
        MuiFab: {
            styleOverrides: {
                root: _define_property({
                    borderRadius: rem(120),
                    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)',
                    gap: rem(8),
                    textTransform: 'none',
                    // Figma shows the same flat shadow at rest, hover, and pressed —
                    // override MUI's default shadow elevation on press.
                    '&:active': {
                        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)'
                    }
                }, "&&&.".concat(fabClasses.disabled), {
                    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)'
                }),
                sizeSmall: _object_spread_props(_object_spread({
                    width: rem(28),
                    height: rem(28),
                    minWidth: rem(28),
                    minHeight: rem(28),
                    padding: rem(4)
                }, typography.action2), _define_property({}, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(16)
                })),
                sizeMedium: _object_spread_props(_object_spread({
                    width: rem(36),
                    height: rem(36),
                    minWidth: rem(36),
                    minHeight: rem(36),
                    padding: rem(8)
                }, typography.action1), _define_property({}, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(20)
                })),
                primary: (_obj = {
                    backgroundColor: c.default.default.background,
                    color: c.default.default.text
                }, _define_property(_obj, "& .".concat(svgIconClasses.root), {
                    color: c.default.default.icon
                }), _define_property(_obj, '&:hover, &.pseudo-hover', {
                    backgroundColor: c.default.hover.background
                }), _define_property(_obj, '&:active, &.pseudo-active', {
                    backgroundColor: c.default.active.background
                }), _define_property(_obj, "&&&.".concat(fabClasses.disabled), _define_property({
                    backgroundColor: c.disabled.background,
                    color: c.disabled.text
                }, "& .".concat(svgIconClasses.root), {
                    color: c.disabled.icon
                })), _obj),
                action: (_obj1 = {
                    backgroundColor: c.action.default.background,
                    color: c.action.default.text
                }, _define_property(_obj1, "& .".concat(svgIconClasses.root), {
                    color: c.action.default.icon
                }), _define_property(_obj1, '&:hover, &.pseudo-hover', {
                    backgroundColor: c.action.hover.background
                }), _define_property(_obj1, '&:active, &.pseudo-active', {
                    backgroundColor: c.action.active.background
                }), _define_property(_obj1, "&&&.".concat(fabClasses.disabled), _define_property({
                    backgroundColor: c.disabled.background,
                    color: c.disabled.text
                }, "& .".concat(svgIconClasses.root), {
                    color: c.disabled.icon
                })), _obj1),
                special: (_obj2 = {
                    background: c.special.default.background,
                    color: c.special.default.text
                }, _define_property(_obj2, "& .".concat(svgIconClasses.root), {
                    color: c.special.default.icon
                }), _define_property(_obj2, '&:hover, &.pseudo-hover', {
                    background: c.special.hover.background
                }), _define_property(_obj2, '&:active, &.pseudo-active', {
                    background: c.special.active.background
                }), _define_property(_obj2, "&&&.".concat(fabClasses.disabled), _define_property({
                    background: c.disabled.background,
                    color: c.disabled.text
                }, "& .".concat(svgIconClasses.root), {
                    color: c.disabled.icon
                })), _obj2)
            },
            variants: [
                // MUI's FabClasses has no `sizeLarge` key (large is Fab's implicit
                // default size, unlike Button/IconButton) — so the large-size override
                // has to live in `variants`, not `styleOverrides.sizeLarge`.
                {
                    props: {
                        size: 'large'
                    },
                    style: _object_spread_props(_object_spread({
                        width: rem(48),
                        height: rem(48),
                        minWidth: rem(48),
                        minHeight: rem(36),
                        padding: rem(12)
                    }, typography.actionLarge), _define_property({}, "& .".concat(svgIconClasses.root), {
                        fontSize: rem(24)
                    }))
                },
                {
                    props: {
                        color: 'special',
                        size: 'large'
                    },
                    style: {
                        padding: rem(12)
                    }
                },
                // Must come last: overrides the fixed `width` set by the size slots/variant
                // above so the extended (labeled) Fab can grow to fit its label, matching
                // Figma (no size state specifies an explicit `width`, only `minWidth`).
                {
                    props: {
                        variant: 'extended'
                    },
                    style: {
                        width: 'auto'
                    }
                },
                // Figma: the extended (labeled) Fab uses asymmetric padding — horizontal
                // padding is one spacing step above the circular Fab's padding at every
                // size, while vertical padding matches the circular Fab.
                {
                    props: {
                        variant: 'extended',
                        size: 'small'
                    },
                    style: {
                        padding: "".concat(rem(4), " ").concat(rem(8)),
                        gap: rem(4)
                    }
                },
                {
                    props: {
                        variant: 'extended',
                        size: 'medium'
                    },
                    style: {
                        padding: "".concat(rem(8), " ").concat(rem(12))
                    }
                },
                {
                    props: {
                        variant: 'extended',
                        size: 'large'
                    },
                    style: {
                        padding: "".concat(rem(8), " ").concat(rem(16))
                    }
                },
                {
                    // Figma: Special/Large keeps the 12px vertical padding (matching
                    // circular Special/Large) instead of the 8px Default/Large/Extended
                    // uses, in both circular and extended forms.
                    props: {
                        color: 'special',
                        size: 'large',
                        variant: 'extended'
                    },
                    style: {
                        padding: "".concat(rem(12), " ").concat(rem(16))
                    }
                }
            ],
            defaultProps: {
                color: 'primary',
                size: 'medium',
                disableTouchRipple: true
            }
        }
    };
    return override;
};

//# sourceMappingURL=Fab.js.map